module.exports = __webpack_public_path__ + "static/media/logo.4fd6100a.png";